import { createUrqlClient } from '@/utils';

export const urqlClient = createUrqlClient();
